export default class InvalidPortalError extends Error {
  constructor(message: string) {
    super(message);
  }
}
